import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles.css';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import heroImg from '../assets/Sample/adrien-bruneau-8cpR_Yf0rQs-unsplash.jpg';
import photo20192022 from '../assets/Sample/rawkkim-KKz6NgO69yQ-unsplash.jpg';
import photo20232024 from '../assets/Sample/ashley-levinson-WKeasi2Xsqw-unsplash.jpg';
import photo2025 from '../assets/Sample/luca-upper-Z-4kOr93RCI-unsplash.jpg';
import photo2026 from '../assets/Sample/hoyoun-lee-Pbnn9cBpoyw-unsplash.jpg';

export default function Project() {
    const location = useLocation();

    // Handle hash scroll
    useEffect(() => {
        const scrollToHash = () => {
            if (location.hash) {
                const element = document.querySelector(location.hash);
                if (element) {
                    // Wait for page to render
                    setTimeout(() => {
                        const headerHeight =
                            document.querySelector('header')?.offsetHeight || 0;
                        const elementPosition =
                            element.getBoundingClientRect().top;
                        const offsetPosition =
                            elementPosition + window.pageYOffset - headerHeight;

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth',
                        });
                    }, 100);
                }
            } else {
                // No hash, scroll to top
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        };

        scrollToHash();
    }, [location]);

    useEffect(() => {
        // Ensure body overflow is restored when component mounts
        document.body.style.overflow = '';

        document.title = 'Our Project - CHOPSTICKSTORY';

        const setMeta = (name, content, prop = false) => {
            if (prop) {
                let el = document.querySelector(`meta[property="${name}"]`);
                if (!el) {
                    el = document.createElement('meta');
                    el.setAttribute('property', name);
                    document.head.appendChild(el);
                }
                el.content = content;
            } else {
                let el = document.querySelector(`meta[name="${name}"]`);
                if (!el) {
                    el = document.createElement('meta');
                    el.setAttribute('name', name);
                    document.head.appendChild(el);
                }
                el.content = content;
            }
        };

        setMeta(
            'description',
            "Explore CHOPSTICKSTORY's journey through our milestones and activities from 2019 to the present.",
        );
        setMeta(
            'keywords',
            'CHOPSTICKSTORY milestones, Korean cultural events, organizational history, cultural education, community events',
        );
        setMeta('author', 'CHOPSTICKSTORY');
        setMeta('og:title', 'Our Project - CHOPSTICKSTORY', true);
        setMeta(
            'og:description',
            'Explore our journey of promoting Korean culture through various milestones and activities since 2019.',
            true,
        );

        // Cleanup: restore overflow on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    return (
        <div className="project-page">
            <PageHero image={heroImg} title="Our Projects" />

            <main className="project-main">
                <p className="project-intro">
                    Follow our journey of sharing Korean culture since 2019.
                </p>

                <section className="milestones" id="milestones">
                    {/* Two independent columns split by a central "chopstick"
                        spine. Each column stacks its own items top-to-bottom so
                        there are no forced row heights (and no vertical gaps from
                        photo/text height mismatches). The order-* classes only
                        re-interleave the two columns back into chronological
                        order when the layout collapses to one column on mobile. */}
                    <div className="project-timeline">
                        <div className="timeline-column timeline-column-left">
                            <div className="segment-media media-2019 order-1">
                                <img src={photo20192022} alt="" />
                            </div>

                            <div className="segment-body order-4">
                                <h3 className="month-heading">2023–2024</h3>
                                <ul className="project-events-list">
                                    <li>
                                        Conducting Korean cultural education
                                        programs at SVKS Korean School.
                                    </li>
                                    <li>
                                        Participated in the SF Chuseok Festival
                                        and Korean Culture Night for local
                                        educators.
                                    </li>
                                    <li>Led sessions at KCI Teen Summit.</li>
                                    <li>Hosted a Google Korean Event.</li>
                                    <li>
                                        Conducted cultural classes for Mercy
                                        &amp; Peace disability program, San Jose
                                        Korean Catholic Church School, and
                                        Cupertino Middle School multicultural
                                        event.
                                    </li>
                                    <li>
                                        Received a grant from The ARTS Council of
                                        the Southern Finger Lakes.
                                    </li>
                                    <li>
                                        Conducted a Korean cultural experience
                                        class at the Corning, NY.
                                    </li>
                                </ul>
                            </div>

                            <div className="segment-media media-2025 order-5">
                                <img src={photo2025} alt="" />
                            </div>

                            <div className="segment-body order-8">
                                <h3 className="month-heading">2026</h3>
                                <ul className="project-events-list">
                                    <li>Cupertino AAPI Multicultural Festival</li>
                                    <li>Mountain View Multicultural Festival</li>
                                    <li>
                                        KPA Tri-Valley Korean Cultural Festival
                                    </li>
                                    <li>
                                        San Francisco Public Library Bernal
                                        Heights Chopsticks workshop
                                    </li>
                                    <li>
                                        San Francisco Public Library Parkside
                                        Chopsticks workshop
                                    </li>
                                    <li>
                                        California High School Dancheong &amp;
                                        Minhwa class
                                    </li>
                                    <li>SVKS Hanji making cultural class</li>
                                    <li>
                                        Pleasanton Virtual Academy Hanji making
                                        workshop
                                    </li>
                                    <li>Cupertino Library Dancheong class</li>
                                    <li>
                                        Branham High School chopsticks making
                                        workshop
                                    </li>
                                    <li>
                                        Milpitas High School Chopsticks making
                                        workshop
                                    </li>
                                    <li>
                                        Emerald High School Mother-of-Pearl craft
                                    </li>
                                    <li>
                                        Mountain View Library Mother-of-Pearl
                                        craft
                                    </li>
                                    <li>Cupertino Library Dancheong class</li>
                                    <li>Saratoga Library Dancheong class</li>
                                    <li>
                                        Brooktree Elementary School Dancheong
                                        class
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="timeline-column timeline-column-right">
                            <div className="segment-body order-2">
                                <h3 className="month-heading">2019–2022</h3>
                                <ul className="project-events-list">
                                    <li>
                                        Completed Chopstick Instructor Training
                                        Program at Incheon Yeonsu-gu Lifelong
                                        Education Center.
                                    </li>
                                    <li>
                                        Conducted a literacy education program
                                        using chopsticks in Songdo, Incheon,
                                        supported by Songdo 2-dong Residents'
                                        Association.
                                    </li>
                                    <li>
                                        Operated a booth at Songdo 4-dong
                                        Resident Event.
                                    </li>
                                    <li>
                                        Selected as a village enterprise for the
                                        Incheon community.
                                    </li>
                                    <li>
                                        Participated in the IFEZ Global Fair for
                                        international cultural exchange.
                                    </li>
                                    <li>
                                        Hosted a cultural experience booth at the
                                        Songdo International Children's Book Fair
                                        in Incheon.
                                    </li>
                                    <li>
                                        Won an award at the Incheon Yeonsu-gu
                                        Startup Competition.
                                    </li>
                                    <li>
                                        Participated in the Arts and
                                        Entrepreneurship Talent Exhibition
                                        organized by IFEZ.
                                    </li>
                                    <li>
                                        Participated in the NC Korean Culture
                                        Experience and 'Squid Game' event.
                                    </li>
                                </ul>
                            </div>

                            <div className="segment-media media-2023 order-3">
                                <img src={photo20232024} alt="" />
                            </div>

                            <div className="segment-body order-6">
                                <h3 className="month-heading">2025</h3>
                                <ul className="project-events-list">
                                    <li>2025 SF Chuseok Festival</li>
                                    <li>
                                        University of San Francisco Chopsticks
                                        workshop
                                    </li>
                                    <li>Cupertino Fall Festival</li>
                                    <li>
                                        Saesomang Korean Church Chopstick making
                                        workshop
                                    </li>
                                    <li>Cupertino AAPI Multicultural Festa 2025</li>
                                    <li>
                                        AKASF (Adopted Korean Americans of San
                                        Francisco)
                                    </li>
                                    <li>
                                        Moonlight Collective — Collaborative
                                        cultural workshop
                                    </li>
                                    <li>Pleasanton Virtual Academy</li>
                                    <li>California High School</li>
                                    <li>Emerald High School</li>
                                    <li>Edison Elementary School</li>
                                    <li>Almaden Korean School</li>
                                </ul>
                            </div>

                            <div className="segment-media media-2026 order-7">
                                <img src={photo2026} alt="" />
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
}
